export var OpenApiScope;
(function (OpenApiScope) {
    OpenApiScope["Metrics"] = "metrics";
    OpenApiScope["DataExport"] = "data-export";
    OpenApiScope["Enrichment"] = "enrichment";
})(OpenApiScope || (OpenApiScope = {}));
export var OAuthGrantType;
(function (OAuthGrantType) {
    OAuthGrantType["ClientCredentials"] = "client_credentials";
    OAuthGrantType["RefreshToken"] = "refresh_token";
    OAuthGrantType["AuthorizationCode"] = "authorization_code";
})(OAuthGrantType || (OAuthGrantType = {}));
export var OAuthResponseType;
(function (OAuthResponseType) {
    OAuthResponseType["Code"] = "code";
    OAuthResponseType["Token"] = "token";
})(OAuthResponseType || (OAuthResponseType = {}));
export var OAuthErrorResponse;
(function (OAuthErrorResponse) {
    OAuthErrorResponse["InvalidRequest"] = "invalid_request";
    OAuthErrorResponse["UnauthorizedClient"] = "unauthorized_client";
    OAuthErrorResponse["AccessDenied"] = "access_denied";
    OAuthErrorResponse["UnsupportedResponseType"] = "unsupported_response_type";
    OAuthErrorResponse["UnsupportedGrantType"] = "unsupported_grant_type";
    OAuthErrorResponse["InvalidScope"] = "invalid_scope";
    OAuthErrorResponse["InvalidClient"] = "invalid_client";
    OAuthErrorResponse["InvalidGrant"] = "invalid_grant";
    OAuthErrorResponse["ServerError"] = "server_error";
    OAuthErrorResponse["TemporarilyUnavailable"] = "temporarily_unavailable";
})(OAuthErrorResponse || (OAuthErrorResponse = {}));
export var OAuthTokenType;
(function (OAuthTokenType) {
    OAuthTokenType["Bearer"] = "bearer";
    OAuthTokenType["Mac"] = "mac";
})(OAuthTokenType || (OAuthTokenType = {}));
//# sourceMappingURL=open-api.js.map